<template>
  <div>
    <!-- Notifications -->
    <v-card class="ml-2">
      <v-card-text class="notifications-container">
        <v-toolbar flat dense :key="-3">
          <v-icon>feedback</v-icon>
          <v-toolbar-title>{{ $t('global.notifications') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="removeAllNotifications()">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-toolbar>
        <v-subheader v-if="$store.state.notificationQueue.length == 0" class="ma-2" :key="-4">
          <b>{{ $t('global.noNotifications') }}</b>
        </v-subheader>
        <div class="notifications-list">
          <div
            v-for="(notification, index) in $store.state.notificationQueue"
            v-bind:key="notification.id"
          >
            <v-card class="elevation-0" :ripple="false" @click="removeNotification(index)">
              <v-card-title class="pb-0">
                <b class="notification-title">
                  <v-icon
                    class="mr-1"
                    :color="notification.level.toLowerCase()"
                  >{{ notification.level.toLowerCase() }}</v-icon>
                  {{ notification.title }}
                </b>
              </v-card-title>
              <v-card-text class="pt-0">
                <p class="ma-0">{{ notification.content }}</p>
                <p class="ma-0 mt-1 notification-time">{{ notification.timeOccured | formatDate("HH:mm") }}</p>
              </v-card-text>
            </v-card>
            <v-divider></v-divider>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

export default {
  name: "notification-list",
  components: {},
  data() {
    return {};
  },
  methods: {
    removeNotification(index) {
      this.$store.state.notificationQueue.splice(index, 1);
    },
    removeAllNotifications() {
      this.$store.state.notificationQueue.splice(
        0,
        this.$store.state.notificationQueue.length
      );
    }
  }
};
</script>
<style scoped>
.list-enter-active,
.list-move {
  transition: all 0.3s;
}
.list-leave-active {
  position: absolute;
  transition: all 0.3s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateX(-500px);
}

.notifications-container {
  height: 800px;
}
.notifications-list {
  max-height: 704px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.notifications-list::-webkit-scrollbar {
  width: 0.5em;
  display: block;
}
.notifications-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.notification-title {
  display: inline-block;
  font-size: 14px;
}
.notification-time {
  font-size: 11px
}
</style>
